import theme from '@/constants/theme';
import React from 'react';

interface Props {
  value: number | string;
}

const Progress: React.FC<Props> = ({ value }) => {
  return (
    <div style={styles.progressBar}>
      <div
        style={{
          ...styles.progressIndicator,
          ...{ width: `${value ?? 0}%` },
        }}
      />
      <div style={styles.progressEmpty} />
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  progressBar: {
    backgroundColor: 'inherit',
    height: 6,
    borderRadius: 4,
    display: 'flex',
    gap: 4,
    flexDirection: 'row',
    maxWidth: '100%',
  },
  progressIndicator: {
    backgroundColor: theme.colors.success,
    height: 6,
    borderRadius: 4,
    width: '80%',
    transition: 'width 0.3s ease-in-out',
  },
  progressEmpty: {
    backgroundColor: theme.colors.text.caption,
    height: 6,
    borderRadius: 4,
    flex: 1,
  },
};

export default Progress;
